<table>
  <tbody>
    <tr>
      @for (d of discounts; track $index; let last = $last) {
        <td [ngClass]="{'bg-discount': isInRange(d.range)}">
          <strong>{{ d.value }} %</strong>
          <br>
          {{ d.range }} {{ (last ? 'orMoreDays' : 'days') | translate }}
        </td>
      }
    </tr>
  </tbody>
</table>
